import { type Guard } from '@capsicum/common';
import { useRouter } from '@capsicum/common-web';
import { useNCWtopUpGuardShared } from '@capsicum/features/nc-wallet/shared';
import { useCallback } from 'react';

/**
 * Check access to the top-up page.
 *
 * @returns {Guard}
 */
export const useNCWtopUpGuard: Guard = () => {
	const { replace } = useRouter();
	const { status } = useNCWtopUpGuardShared();

	const onDenied = useCallback(() => replace('/nc-wallet'), [replace]);

	return {
		onDenied,
		status
	};
};
